import "./DatiPersonaliNonRiconosciutoPage.css";
import { t } from "../../services/formatters";
import { Button } from "../../components/Button";
// import { Riepilogo } from "../../components/Riepilogo";
import { Breadcrumb } from "../../components/Breadcrumb";
import { FormDatiUtente } from "../../components/FormDatiUtente";
import { Informative } from "../../components/Informative";
import { useDatiPersonaliNonRiconosciutoPage } from "./useDatiPersonaliNonRiconosciutoPage";
import { ErrorModal } from "../../components/ErrorModal";
import { useEffect } from "react";
import {Riepilogo} from "../../components/Riepilogo";

export const DatiPersonaliNonRiconosciutoPage = () => {
  const { next, read, lockFields, isCreaAppuntamentoBusy, isCreaAppuntamentoError, fetchErrorMessage, fetchError, setFetchError } = useDatiPersonaliNonRiconosciutoPage();

  useEffect(() => {
    window.dataLayer.push({
      event: "customPageview",
      virtualPageURL: "/fa3/fissa-appuntamento/dati-personali",
      crmIdentification: "nuovo utente",
      funnelVersion: "nuovo",
      capFiliale: read("cap"),
      presa_info: read("solo_info"),
    });
  }, []);

  return (
    <div id="dati-personali-non-riconosciuto-page">
      <Breadcrumb />

      {lockFields && (
        <div className={`section page-title-component center-on-tablet`}>
          <h1>
            <span>Ciao {read("nome")}!</span>
          </h1>
        </div>
      )}

      {read("id_filiale_direct") && (
        <Riepilogo />
      )}

      <FormDatiUtente lockFields={lockFields} title={t("compila_dati")} />

      <Informative />

      <div className="section text-center">
        <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("fissa_appuntamento")} />
        {/* {isCreaAppuntamentoError() && <p>errore crea</p>} */}
      </div>

      <ErrorModal
        open={fetchError}
        text={fetchErrorMessage}
        onCloseModal={() => {
          setFetchError(false);
        }}></ErrorModal>
    </div>
  );
};
